import { render, staticRenderFns } from "./searchList-news.vue?vue&type=template&id=fe4ea3f4&scoped=true"
import script from "./searchList-news.vue?vue&type=script&lang=js"
export * from "./searchList-news.vue?vue&type=script&lang=js"
import style0 from "./searchList-news.vue?vue&type=style&index=0&id=fe4ea3f4&prod&lang=scss"
import style1 from "./searchList-news.vue?vue&type=style&index=1&id=fe4ea3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4ea3f4",
  null
  
)

export default component.exports